import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { LayoutHome } from "../LayoutHome";
import moment from "moment/moment";
import {
  Box,
  Panel,
  SelectPicker,
  Text,
  Modal,
  Message,
  toaster,
  Popover,
  Whisper,
  Checkbox,
  TimePicker,
} from "rsuite";
import { Input, notification, Splitter, Button, Form, InputNumber } from "antd";
import Popup from "reactjs-popup";
import Table from "react-bootstrap/Table";
import {
  getTurnos,
  getHorariosTurno,
  getInsumosSesion,
} from "../Services/SesionHemoServices";
import {
  getVerificaProc,
  getPacientesSesion,
  getDatospacienteView,
  getAccesoVascular,
  getDataFiltro,
  getNumSesionesSem,
  getHoraActual,
  iniciaHojaEnf,
  getHojaEnfermeria,
  saveCampoHoja,
  saveSeguimiento,
  getSeguimientos,
  saveVerificaPre,
  saveHoraAplica,
  saveFirmaHojaEnf,
} from "../Services/HojaEnfermeria";
import { soloNumeros } from "../../Utils";
import {
  Check,
  DoorClosed,
  Eraser,
  LucideAArrowDown,
  PlusCircleIcon,
  RefreshCcw,
  Save,
} from "lucide-react";
import { Image } from "react-bootstrap";
import { confApp } from "../../CONF_APP";
import { useReactToPrint } from "react-to-print";

const { TextArea } = Input;

export const HojaEnfermeriaView = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [camposHojaEnf] = useState(
    JSON.parse(localStorage.getItem("auth")).camposHojaEnf,
  );

  const [form] = Form.useForm();
  const [formLayout] = useState("horizontal");

  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const idEnf = JSON.parse(localStorage.getItem("auth")).idEnf;

  const nombreUser = JSON.parse(localStorage.getItem("auth")).nombre;

  const { idSesion, idPaciente } = useParams();
  const [date, setDate] = useState("");

  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);
  const modal = useRef();
  const componentRef = useRef();

  const [idHojaEnf, setIdHojaEnf] = useState(0);
  const [fechaHoja, setFechaHoja] = useState("");
  const [hora, setHora] = useState("");
  const [dataHorarios, setDataHorarios] = useState([]);
  const [dataVerificaProc, setDataVerificaProc] = useState([]);
  const [turno, setTurno] = useState("");
  const [paciente, setPaciente] = useState("");
  const [idMaq, setIdMaq] = useState(0);
  const [identifica, setIdentifica] = useState("");
  const [pesoIngreso, setPesoIngreso] = useState(0);
  const [pesoSeco, setPesoSeco] = useState(0);
  const [pesoRemover, setPesoRemover] = useState(0);
  const [serologia, setSerologia] = useState("");
  const [seroPositiva, setSeroPositiva] = useState("");
  const [tensionArt, setTensionArt] = useState("");
  const [frecCard, setFrecCard] = useState(0);
  const [frecResp, setFrecResp] = useState(0);
  const [temp, setTemp] = useState(0);
  const [dataAccesoVasc, setADataccesoVasc] = useState([]);
  const [idAccesoVasc, setIdAccesoVasc] = useState(0);
  const [cveAccesoVasc, setCveAccesoVasc] = useState("");

  const [listInsumos, setListInsumos] = useState([]);
  const [idFiltro, setIdFiltro] = useState("");
  const [idAsigna, setIdAsigna] = useState(0);
  const [tipoDial, setTipoDial] = useState("");
  const [superficieDial, setSuperficieDial] = useState("");
  const [filtro, setFiltro] = useState({});
  const [numReusos, setNumReusos] = useState(0);
  const [tiempoDial, setTiempoDial] = useState("");
  const [entradaDial, setEntradaDial] = useState("");
  const [liquidoDial, setLiquidoDial] = useState(0);
  const [perfilNa, setPerfilNa] = useState("0");
  const [perfilUf, setPerfilUf] = useState("0");
  const [heparinaBolo, setHeparinaBolo] = useState(0);
  const [infusion, setInfusion] = useState(0);
  const [solucionHemo, setSolucionHemo] = useState("");
  const [dataTotalHep] = useState(confApp.VALORES_HEPARINA_BOLO);
  const [dataPErfilUfNa] = useState(confApp.PERFIL_UF_NA);
  const [totalHep, setTotalHep] = useState(0);

  const [zeroSelected, setZeroelected] = useState(false);
  const [oneSelected, setOneSelected] = useState(false);
  const [twoSelected, setTwoSelected] = useState(false);
  const [threeSelected, setThreeSelected] = useState(false);
  const [fourSelected, setFourSelected] = useState(false);
  const [fiveSelected, setFiveSelected] = useState(false);
  const [escalaDolor, setEscalaDolor] = useState(0);
  const [pesoEgreso, setPesoEgreso] = useState(0);
  const [sangreProc, setSangreProc] = useState(0);
  const [ultraFiltra, setUltraFiltra] = useState(0);
  const [horaEgreso, setHoraEgreso] = useState("");
  const [presionArtEgreso, setPresionArtEgreso] = useState(0);
  const [fcEgreso, setFcEgreso] = useState(0);
  const [frEgreso, setFrEgreso] = useState(0);
  const [tempEgreso, setTempEgreso] = useState(0);
  const [gradoRiesgo, setGradoRiesgo] = useState(null);
  const [observa, setObserva] = useState("");

  const [dataPacientes, setDataPacientes] = useState([]);
  const [dataTurnos, setDataTurnos] = useState([]);
  const [dataSegs, setDataSegs] = useState([]);
  const [noSesion, setNoSesion] = useState(0);
  const [edad, setEdad] = useState(0);
  const [sexo, setSexo] = useState("");
  const [dataFirma, setDataFirma] = useState("");
  const [enfermera, setEnfermera] = useState("");
  const [imageFirmaPac, setImageFirmaPac] = useState(null);
  const [imageFirmaEnf, setImageFirmaEnf] = useState(null);
  const [loadFirmaEnf, setLoadFirmaEnf] = useState(null);
  const [loadFirmaPac, setLoadFirmaPac] = useState(null);

  const [estatusHojaEnf, setEstatusHojaEnf] = useState("");
  const [camposVerifica, setCamposVerifica] = useState(0);
  const [hojaValida, setHojaValida] = useState(false);

  const handleCloseModalSerolog = () => {
    setOpenModalSerolog(false);
    setSeroPositiva("");
    setSerologia("");
  };
  const handleCloseModalSeg = () => {
    setOpenModalSeg(false);
  };
  const handleCloseModalInicia = () => {
    setOpenModalInicia(false);
  };

  const handleCloseModalFirma = () => {
    setOpenModalFirma(false);
  };

  const [idSegHojaEnf, setIdSegHojaEnf] = useState(0);

  const [openModalSeg, setOpenModalSeg] = useState(false);
  const [openModalSerolog, setOpenModalSerolog] = useState(false);
  const [openModalInicia, setOpenModalInicia] = useState(false);
  const [openModalMedics, setOpenModalMedics] = useState(false);
  const [openModalFirma, setOpenModalFirma] = useState(false);
  const [loadingInicio, setLoadingInicio] = useState(false);
  const [horaAplica, setHoraAplica] = useState("");

  // CONSTANTES DE SEGUIMIENTO
  const [horaSeg, setHoraSeg] = useState("");

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const getPageMargins = (marginTop, marginRight, marginBottom, marginLeft) => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
  };

  const marginTop = "5mm";
  const marginRight = "5mm";
  const marginBottom = "55mm";
  const marginLeft = "5mm";

  const handlePrint = useReactToPrint({
    documentTitle: "Nota Médica",
    contentRef: componentRef,
    pageStyle: getPageMargins(marginTop, marginRight, marginBottom, marginLeft),
  });

  const styleFont = "#4B86D1";

  const loadTurnos = async () => {
    await getTurnos(idNegocio)
      .then((res) => {
        setDataTurnos(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const handleEscalasSelected = (props) => {
    if (props.opc === 0) {
      setZeroelected(true);
      setOneSelected(false);
      setTwoSelected(false);
      setThreeSelected(false);
      setFourSelected(false);
      setFiveSelected(false);
    }
    if (props.opc === 1) {
      setZeroelected(false);
      setOneSelected(true);
      setTwoSelected(false);
      setThreeSelected(false);
      setFourSelected(false);
      setFiveSelected(false);
    }
    if (props.opc === 2) {
      setZeroelected(false);
      setOneSelected(false);
      setTwoSelected(true);
      setThreeSelected(false);
      setFourSelected(false);
      setFiveSelected(false);
    }
    if (props.opc === 3) {
      setZeroelected(false);
      setOneSelected(false);
      setTwoSelected(false);
      setThreeSelected(true);
      setFourSelected(false);
      setFiveSelected(false);
    }
    if (props.opc === 4) {
      setZeroelected(false);
      setOneSelected(false);
      setTwoSelected(false);
      setThreeSelected(false);
      setFourSelected(true);
      setFiveSelected(false);
    }
    if (props.opc === 5) {
      setZeroelected(false);
      setOneSelected(false);
      setTwoSelected(false);
      setThreeSelected(false);
      setFourSelected(false);
      setFiveSelected(true);
    }
    setEscalaDolor(props.opc);

    if (props.upd === 1)
      updateCampo("escalaDolor", {
        target: {
          value: props.opc,
        },
      });
  };

  const loadVerificaPreProc = async () => {
    await getVerificaProc(idNegocio, idSesion)
      .then((res) => {
        setDataVerificaProc(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const validacionCierre = () => {
    let hojaValida = true;

    if (
      estatusHojaEnf === "Cerrada" &&
      dataSegs.length > 2 &&
      gradoRiesgo !== null &&
      camposVerifica === dataVerificaProc.length
    ) {
      return hojaValida;
    } else {
      hojaValida = false;
      return hojaValida;
    }

    if (estatusHojaEnf !== "Cerrada") {
      errorNotificaction(
        "Datos incompletos",
        "La hoja de enfermería no se encuentra cerrada, revisa todos los campos.",
      );
      hojaValida = false;
    }
    if (dataSegs.length < 3) {
      errorNotificaction(
        "Datos incompletos",
        "Debe registrar al menos 3 seguimientos para cerrar la hoja de enfermería.",
      );
      hojaValida = false;
    }
    if (gradoRiesgo === null) {
      errorNotificaction(
        "Datos incompletos",
        "Debe seleccionar el grado de riesgo de caída.",
      );
      hojaValida = false;
    }
    if (camposVerifica !== dataVerificaProc.length) {
      errorNotificaction(
        "Datos incompletos",
        "Debe completar todos los campos de verificación.",
      );
      hojaValida = false;
    }
    return hojaValida;
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const handleSeroPositiva = (e) => {
    setSeroPositiva(e);
    updateCampo("seroPositiva", e);
    setOpenModalSerolog(false);
  };

  const cleanForm = () => {
    form.resetFields();
  };

  const handleChangeSero = (e) => {
    if (e === null) {
      setSerologia("");
      setSeroPositiva("");
      return;
    }

    setSerologia(e);
    updateCampo("serologia", {
      target: {
        value: e,
      },
    });
    if (e === "Positiva") {
      setOpenModalSerolog(true);
    }
  };

  const addSeguimiento = async (values) => {
    const newObj = {
      ...values,
      id: idNegocio,
      idHojaEnf: idHojaEnf,
      idSeg: idSegHojaEnf,
    };

    await saveSeguimiento(newObj)
      .then((res) => {
        if (res.data > 0) {
          loadSeguimientos(idHojaEnf);
          successNotification(
            "Seguimiento",
            "Se han registrado los valores de forma correcta.",
          );
          setOpenModalSeg(false);
        } else {
          errorNotificaction("Error", "Ocurrio un error al guardar...");
        }
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const validateMessages = {
    required: "* Obligatorio",
    types: {
      email: "* El campo de correo no es valido",
      number: "* El campo no es un número!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };

  const updateCampo = async (campo, e) => {
    const data = {
      id: idNegocio,
      ttlCamposValida: camposHojaEnf,
      idSesion: idSesion,
      idHojaEnf: idHojaEnf,
      idPac: idPaciente,
      idMaq: idMaq,
      idFiltro: idFiltro,
      campo: `${campo}=${e.target.value}`,
    };

    await saveCampoHoja(data)
      .then((res) => {
        if (res.data === -1) {
          return;
        }

        setEstatusHojaEnf(res.data);
        toast("El dato se ha actualizado de forma correcta.", "success");
      })
      .catch((err) => {
        toast("El dato no se actualizo, valide la información.", "warning");
      });
  };

  // const handleOpenModalInicia = (e) => {
  //   if (e === null) {
  //     setIdSesion(0);
  //     setDataVerificaProc([]);
  //     setEdad(0);
  //     setSexo("");
  //     return;
  //   }

  //   const selectedItem = dataPacientes.find((item) => item.value === e);
  //   setIdPaciente(e);
  //   setPaciente(selectedItem.label);
  //   setOpenModalInicia(true);
  // };

  const loadInicioSesion = async (props) => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      idPaciente: idPaciente,
      idEnf: idEnf,
      idPac: props.idPac,
      idMaq: props.idMaq,
      idFiltro: props.idFiltro,
      pesoIngreso: props.pesoIngreso,
      noSesionSem: props.noSesion,
    };

    var _idHoja = 0;
    var _idSesion = 0;
    await getHojaEnfermeria(idNegocio, idSesion)
      .then((res) => {
        _idHoja = res.idHoja;
        setIdHojaEnf(res.idHoja);
        setFechaHoja(res.fechaHoja);
        setCveAccesoVasc(res.accesoVasc);
        setTipoDial(res.filtro.Tipo);
        setSuperficieDial(res.filtro.IdClasifica);
        setNoSesion(res.noSesion);
        setEnfermera(res.enfermera);
        setPesoSeco(res.pesoSeco);
        setPesoRemover(res.pesoRemover);
        setEntradaDial(res.horaEntrada);
        setPesoRemover(res.pesoRemover);
        var _horaEnt = res.horaEntrada;
        var horaEnt = "";
        if (_horaEnt.length > 0) {
          horaEnt = _horaEnt.substring(0, 5);
        }

        setIdAccesoVasc(res.idAccesoVasc);
        setEntradaDial(horaEnt);
        setSerologia(res.serologia);
        setSeroPositiva(res.seroPositiva);
        setTensionArt(res.presionArt);
        setFrecCard(res.fc);
        setFrecResp(res.fr);

        setTemp(res.temp);

        var _tiempoDial = res.tiempoDial === null ? "00:00" : res.tiempoDial;
        if (_tiempoDial.length > 0) {
          _tiempoDial = res.tiempoDial;
        }
        setTiempoDial(_tiempoDial);

        setLiquidoDial(res.flujoDial);
        setPerfilNa(res.perfilNa === null ? "0" : String(res.perfilNa));
        setPerfilUf(res.perfilUf === null ? "0" : String(res.perfilUf));

        setHeparinaBolo(res.heparinaBolo);
        setInfusion(res.infusion);
        setTotalHep(res.ttlAntiCoag);
        setSangreProc(res.sangreProc);
        setPesoEgreso(res.pesoEgreso);
        setUltraFiltra(res.ultraFiltraTtl);
        var _horaEgreso = res.horaEgreso;
        if (_horaEgreso.length > 0) {
          _horaEgreso = _horaEgreso.substring(0, 5);
        }
        setHoraEgreso(_horaEgreso);
        setPresionArtEgreso(res.presionArtEgreso);
        setFcEgreso(res.fcEgreso);
        setFrEgreso(res.frEgreso);
        setTempEgreso(res.tempEgreso);
        setEscalaDolor(res.escalaDolor);

        handleEscalasSelected({
          opc: res.escalaDolor,
          upd: 0,
        });

        setGradoRiesgo(res.riesgoCaida);
        setLoadFirmaEnf(res.firmaEnf);
        setLoadFirmaPac(res.firmaPac);

        setObserva(res.obs);
      })
      .then(async (res) => {
        await getVerificaProc(idNegocio, _idHoja).then((res) => {
          setDataVerificaProc(res);
        });
      })
      .then(async (res) => {
        loadSeguimientos(_idHoja);
      })
      .catch((err) => {
        setLoadingInicio(false);
        errorNotificaction(err.name, err.message);
      });
  };

  const handleChecked = (e, opc) => {
    var valorChecked = e;
    if (!e) {
      opc = null;
    }
    updateCampo("riesgoCaida", {
      target: {
        value: opc,
      },
    }).then((res) => {
      setGradoRiesgo(opc);
    });
  };

  const loadDatosPaciente = async () => {
    var _idFiltro = "";
    var _idAsigna = 0;
    var _idSesion = 0;
    var _idPaciente = 0;
    var _pesoIngreso = 0;
    var _idMaq = 0;
    var _noSesiones = 0;

    await getDatospacienteView(idNegocio, idSesion)
      .then((response) => {
        _idSesion = idSesion;
        _idPaciente = idPaciente;
        _pesoIngreso = response.pesoInicial;
        _idMaq = response.idMaquina;

        let _fecha = response.fechaNac;
        if (_fecha !== null) {
          var _fecNac = new Date(response.fechaNac);
          _fecNac.setDate(_fecNac.getDate() + 1);
          calculaEdad(_fecNac);
        } else {
          setEdad(0);
        }
        setPaciente(response.paciente);
        setSexo(response.genero);
        setPesoIngreso(response.pesoInicial);
        setIdMaq(response.idMaquina);
        setIdentifica(response.identifica);
        setIdFiltro(response.idFiltro);
        _idFiltro = response.idFiltro;
        setIdAsigna(response.idAsigna);
        _idAsigna = response.idAsigna;
      })
      .then(async (res) => {
        await getInsumosSesion(idNegocio, _idSesion)
          .then(async (res) => {
            setListInsumos(res);
          })
          .then(async (res) => {
            loadInicioSesion({
              idSesion: _idSesion,
              idPac: _idPaciente,
              idFiltro: _idFiltro,
              idMaq: _idMaq,
              pesoIngreso: _pesoIngreso,
              noSesion: _noSesiones,
            });
          })
          .then(async (res) => {
            await getAccesoVascular(idNegocio).then((res) => {
              setADataccesoVasc(res);
            });
          });
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const handleOpenModalFirma = (firma) => {
    if (estatusHojaEnf === "Finalizada") {
      return;
    }
    const cierreValido = validacionCierre();

    if (cierreValido) {
      if (firma === "Paciente" && imageFirmaEnf === null) {
        errorNotificaction(
          "Firma enfermero(a)",
          "Ingresa tú firma antes de continuar.",
        );
        return;
      }
      setDataFirma(`${firma}`);
      setOpenModalFirma(true);
    } else {
      errorNotificaction(
        "Validación de cierre",
        "No es posible abrir el modal de firma, revise que la hoja de enfermería esté cerrada y que se hayan registrado al menos 3 seguimientos, además de completar los campos de verificación.",
      );
    }
  };

  const updateHora = async (props) => {
    if (props.hora === "HH:mm") {
      return;
    }

    const data = {
      id: idNegocio,
      idSesion: idSesion,
      noItem: props.noItem,
      idInsumo: props.idInsumo,
      hora: props.hora,
    };

    await saveHoraAplica(data)
      .then(async (res) => {
        if (res.data > 0) {
          toast("Se actualizó la hora de aplicación del insumo", "success");
          await getInsumosSesion(idNegocio, idSesion)
            .then((res) => {
              setListInsumos(res);
            })
            .catch((err) => {
              errorNotificaction(err.name, err.message);
            });
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  // const getDataOfCell = (e, rowIndex, colName, noItem, idInsumo) => {
  //   const newValue = e.target.innerText; // or innerHTML
  //   const updatedData = [...listInsumos];
  //   updatedData[rowIndex][colName] = newValue;

  //   console.log(data);
  // };

  const getDataOfCellChange = (e, rowIndex) => {
    const newValue = e.target.innerText;
    newValue.Body.replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "$1:$2")
      .replace(/(\d{2})(\d)/, "$1:$2");

    const updatedData = [...listInsumos];
    updatedData[rowIndex]["hora"] = newValue;
  };

  const handleTotalHep = (e) => {
    if (e === null) {
      setTotalHep(0);
      e = 0;
    }

    setTotalHep(e);
    const obj = {
      target: {
        value: e,
      },
    };
    updateCampo("totalHep", obj);
  };

  const loadSeguimientos = async (idHoja) => {
    await getSeguimientos(idNegocio, idHoja).then((res) => {
      setDataSegs(res);
    });
  };

  const handleHeparinaBolo = (e) => {
    if (e === null) {
      setHeparinaBolo(0);
      e = 0;
    }
    setHeparinaBolo(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("heparinaBolo", obj);
  };

  const handleUpdatePerfilUF = (e) => {
    if (e === null) {
      setPerfilUf(0);
      e = 0;
    }
    setPerfilUf(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("perfilUf", obj);
  };

  const handleUpdatePerfilNa = (e) => {
    if (e === null) {
      setPerfilNa(0);
      e = 0;
    }
    setPerfilNa(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("perfilNa", obj);
  };

  const handleInfusion = (e) => {
    if (e === null) {
      setInfusion(0);
    }
    setInfusion(e);
    const obj = {
      target: {
        value: e,
      },
    };
    updateCampo("infusion", obj);
  };

  const saveFirma = async (firmaEnf, firmaPac) => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      idHoja: idHojaEnf,
      firmaEnf: firmaEnf,
      firmaPac: firmaPac,
    };
    await saveFirmaHojaEnf(data)
      .then((res) => {
        setEstatusHojaEnf(res.data);
        setOpenModalFirma(false);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleAccesoVasc = (e) => {
    setIdAccesoVasc(e);
    if (e !== null) {
      const obj = {
        target: {
          value: e,
        },
      };
      updateCampo("idAccesoVasc", obj);
    }
  };

  const handleObserva = (e) => {
    setObserva(e.target.value);
  };

  const loadInsumos = async () => {
    await getInsumosSesion(idNegocio, idSesion)
      .then(async (res) => {
        setListInsumos(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleModalOpenSeg = async () => {
    await getHoraActual().then((res) => {
      setHoraSeg(res);
      cleanForm();
      setOpenModalSeg(true);
    });
  };

  const handleFocus = (event) => event.target.select();

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadDatosPaciente();
    }
  }, []);

  return (
    <>
      <title>Hoja de Enfermería Vista</title>
      <div ref={componentRef}>
        <Image
          src={`/Images/Negocios/${idNegocio}/cornerImageHoja.png`}
          style={{
            width: "450px",
            position: "absolute",
            right: "0%",
            top: "0%",
            zIndex: "-1",
          }}
        />
        <div
          style={{ marginLeft: "50px", marginTop: "50px", marginRight: "50px" }}
        >
          <Panel>
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-3">
                <Image
                  src={`/Images/Negocios/${idNegocio}/Logo.png`}
                  height={"80ox"}
                />
              </div>
              <div className="text-center col-lg-5-col-md-5 col-sm-5">
                <br></br>
                <Text size={"xl"} weight="bold" color={styleFont} style={{ cursor: "pointer" }} onClick={() => handlePrint()}>
                  HOJA DE ENFERMERÍA PARA HEMODIÁLISIS
                </Text>
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1">&nbsp;</div>
              <div className="text-center col-lg-3 col-md-3 col-sm-3">
                <br></br>
                <Box
                  mb={2}
                  bd="1px solid var(--rs-border-primary)"
                  rounded="lg"
                  style={{ padding: "5px" }}
                >
                  <Text size={"lg"} weight="semibold" color={styleFont}>
                    Folio No. {idHojaEnf}
                  </Text>
                </Box>
              </div>
            </div>
          </Panel>
          <Panel>
            <div className="row mb-2">
              <table style={{ color: styleFont }}>
                <tr>
                  <th style={{ textAlign: "right " }}>
                    <Text size={"sm"} weight="semibold" color={styleFont}>
                      NOMBRE:
                    </Text>
                  </th>
                  <th style={{ color: styleFont }}>
                    <Input
                      readOnly
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: styleFont,
                      }}
                      variant="underlined"
                      value={paciente}
                    />
                  </th>
                  <th style={{ textAlign: "right " }}>
                    <Text size={"sm"} weight="semibold" color={styleFont}>
                      EDAD:
                    </Text>
                  </th>
                  <th>
                    <Input
                      readOnly
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: styleFont,
                      }}
                      variant="underlined"
                      value={edad}
                    />
                  </th>
                  <th style={{ textAlign: "right " }}>
                    <Text size={"sm"} weight="semibold" color={styleFont}>
                      SEXO:
                    </Text>
                  </th>
                  <th>
                    <Input
                      readOnly
                      variant="underlined"
                      color={styleFont}
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: styleFont,
                      }}
                      value={sexo}
                    />
                  </th>
                  <th style={{ textAlign: "right " }}>
                    <Text size={"sm"} weight="semibold" color={styleFont}>
                      FECHA:{" "}
                    </Text>
                  </th>
                  <th style={{ textAlign: "center" }}>
                    <Input
                      readOnly
                      variant="underlined"
                      style={{ textAlign: "center", color: styleFont }}
                      value={fechaHoja.toUpperCase()}
                    />
                  </th>
                </tr>
              </table>
            </div>
          </Panel>
          <div className="row mb-1"></div>
          <Splitter style={{ overflowX: "hidden" }}>
            <Splitter.Panel
              style={{ padding: "2px", overflowX: "hidden" }}
              defaultSize="75%"
              min="40%"
              max="80%"
            >
              <div className="row mb-1">
                <div className="text-center col">
                  <Text size={"xl"} weight="bold" color={styleFont}>
                    PREDIÁLISIS
                  </Text>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Table
                    key={`tblPreDial`}
                    bordered
                    size="md"
                    style={{ width: "99%", color: styleFont }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Text color={styleFont}>Peso de ingreso:</Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {pesoIngreso}
                          </Text>
                        </th>
                        <th>
                          <Text color={styleFont}>Peso Seco:</Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {pesoSeco}
                          </Text>
                        </th>
                        <th colSpan={2}>
                          <Text color={styleFont}>Peso a remover:</Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {pesoRemover}
                          </Text>
                        </th>
                        <th colSpan={2} style={{ textAlign: "center" }}>
                          <Text color={styleFont}>Hora de entrada</Text>
                        </th>
                        <th style={{ textAlign: "center" }} colSpan={4}>
                          <Text size={"sm"} color={styleFont}>
                            {entradaDial}
                          </Text>
                        </th>
                      </tr>
                      <tr>
                        <th>
                          <Text color={styleFont}>Acceso vascular:</Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {cveAccesoVasc}
                          </Text>
                        </th>
                        <th>
                          <Whisper
                            placement="top"
                            trigger="click"
                            speaker={
                              <Popover
                                title={
                                  seroPositiva !== ""
                                    ? "Serología Positiva"
                                    : ""
                                }
                              >
                                <Text size={"md"}>{seroPositiva}</Text>
                              </Popover>
                            }
                          >
                            <Text color={styleFont}>Serología</Text>
                          </Whisper>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text color={styleFont} size={"sm"}>
                            {serologia}
                          </Text>
                        </th>
                        <th>
                          <Text color={styleFont}>Signos vitales</Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            TA:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {tensionArt}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            FC:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {frecCard}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            FR:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {frecResp}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            T:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {temp}
                          </Text>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
              </div>
              <div className="row">
                <div className="text-center col">
                  <Text size={"xl"} weight="bold" color={styleFont}>
                    DIÁLISIS
                  </Text>
                  <Table
                    key={`tblDial`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%" }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            No. de Sesión
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          {noSesion}
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Maquina Núm:
                          </Text>{" "}
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          {identifica}
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Dializador tipo:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          {tipoDial}
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Superficie:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          {superficieDial}
                        </th>
                      </tr>
                      <tr>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Núm de Rehuso:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          {numReusos}
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Tiempo de diálisis
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          <Text size={"sm"} color={styleFont}>
                            {tiempoDial}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Liquido dializante:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          <Text size={"sm"} color={styleFont}>
                            {liquidoDial}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Perfil de Na
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          <Text size={"sm"} color={styleFont}>
                            {perfilNa}
                          </Text>
                        </th>
                      </tr>
                      <tr>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Perfil de Uf:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          <Text size={"sm"} color={styleFont}>
                            {perfilUf}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Heparina Bolo:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          <Text size={"sm"} color={styleFont}>
                            {heparinaBolo}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Infusión:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          <Text size={"sm"} color={styleFont}>
                            {infusion}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Total:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          <Text size={"sm"} color={styleFont}>
                            {totalHep}
                          </Text>
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={2} style={{ textAlign: "left" }}>
                          <Text size={"sm"} color={styleFont}>
                            Soluciones y/o hemoderivados:
                          </Text>
                        </th>
                        <th colSpan={6}>
                          <Text size={"sm"} color={styleFont}>
                            {solucionHemo}
                          </Text>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <Table
                    key={`tblSeguimiento`}
                    bordered
                    responsive
                    size="md"
                    style={{ fontSize: "12px" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          HORA
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          TEMP.
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          F.C.
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          F.R.
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          TA
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          FD
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          FS
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          PV
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          TMP
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          NA
                        </th>
                        <th style={{ textAlign: "center", color: styleFont }}>
                          UF
                        </th>
                      </tr>
                    </thead>
                    {dataSegs.length > 0
                      ? dataSegs.map((item, index) => {
                          return (
                            <tbody>
                              <tr key={index}>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.hora.substring(0, 5)}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.temp}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.fc}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.fr}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.ta}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.fd}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.fs}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.pv}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.tmp}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.na}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: styleFont,
                                  }}
                                >
                                  {item.uf}
                                </td>
                              </tr>
                            </tbody>
                          );
                        })
                      : ""}
                  </Table>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <Table
                    key={`tblMedics`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%", fontSize: "14px" }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Medicamentos
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            Hora aplicación
                          </Text>
                        </th>
                      </tr>
                    </thead>
                    {listInsumos.length > 0 ? (
                      <tbody>
                        {listInsumos.map((item, index) => {
                          return (
                            <tr key={`row-${index}`}>
                              <td style={{ color: styleFont }}>
                                {item.insumo}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  color: styleFont,
                                }}
                              >
                                {item.hora}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : (
                      ""
                    )}
                  </Table>
                </div>
              </div>
              <div className="row">
                <center>
                  <Text size={"xl"} weight="bold" color={styleFont}>
                    POST DIÁLISIS
                  </Text>
                </center>
                <div className="text-center col-lg-8 col-md-8 col-sm-8">
                  <Table
                    key={`tblPostDial`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%", fontSize: "14px" }}
                  >
                    <thead>
                      <tr>
                        <th colSpan={2}>
                          <Text size={"sm"} color={styleFont}>
                            Sangre procesada:
                          </Text>
                        </th>
                        <th colSpan={2} style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {sangreProc}
                          </Text>
                        </th>
                        <th colSpan={2}>
                          <Text size={"sm"} color={styleFont}>
                            Peso egreso:
                          </Text>
                        </th>
                        <th colSpan={2}>
                          <Text size={"sm"} color={styleFont}>
                            {pesoEgreso}
                          </Text>
                        </th>
                        <th colSpan={2}>
                          <Text size={"sm"} color={styleFont}>
                            UFT:
                          </Text>
                        </th>
                        <th colSpan={2}>
                          <Text size={"sm"} color={styleFont}>
                            {ultraFiltra}
                          </Text>
                        </th>
                      </tr>
                      <tr>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Hora egreso
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {horaEgreso}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            Signos Vitales:
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            TA:
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            {presionArtEgreso}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            FC:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {fcEgreso}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            FR:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {frEgreso}
                          </Text>
                        </th>
                        <th>
                          <Text size={"sm"} color={styleFont}>
                            T:
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            {tempEgreso}
                          </Text>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <Table
                    key={`tblPostDial`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%", fontSize: "14px" }}
                  >
                    <thead>
                      <tr>
                        <th
                          rowSpan={3}
                          style={{ width: "10%", alignContent: "top" }}
                        >
                          <Text size={"sm"} color={styleFont}>
                            Escala del dolor:
                          </Text>
                        </th>
                      </tr>
                      <tr>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !zeroSelected
                                ? "/Images/faces/excellent.jpg"
                                : "/Images/faces/excellentSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !oneSelected
                                ? "/Images/faces/good.jpg"
                                : "/Images/faces/goodSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !twoSelected
                                ? "/Images/faces/medium.jpg"
                                : "/Images/faces/mediumSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !threeSelected
                                ? "/Images/faces/poor.jpg"
                                : "/Images/faces/poorSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !fourSelected
                                ? "/Images/faces/verybad.jpg"
                                : "/Images/faces/verybadSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !fiveSelected
                                ? "/Images/faces/highlybad.jpg"
                                : "/Images/faces/highlybadSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            0
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            1
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            2
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            3
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            4
                          </Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Text size={"sm"} color={styleFont}>
                            5
                          </Text>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
              </div>
              <div className="row mb-2">
                <div
                  className="col-lg-12 col-md-12 col-sm-12"
                  style={{
                    borderBottom: "solid 0.1em",
                    borderBottomColor: styleFont,
                  }}
                >
                  <Text weight="semibold" color={styleFont}>
                    Obsrevaciones:
                  </Text>
                  <Text size={"sm"} color={styleFont}>
                    {observa}
                  </Text>
                </div>
              </div>
              <div className="row mb-1">
                {loadFirmaEnf && imageFirmaEnf === null && (
                  <div className="text-center col-lg-6 col-md-6 col-sm-6">
                    <img
                      src={`Unidades/${idNegocio}/Sesiones/${idSesion}/FirmasHojaEnf/${loadFirmaEnf}`}
                      alt="signature"
                      style={{
                        height: "200px",
                        padding: "10px",
                        zIndex: "-1",
                      }}
                    />
                  </div>
                )}
                {loadFirmaPac && imageFirmaPac === null && (
                  <div className="text-center col-lg-6 col-md-6">
                    <img
                      src={`Unidades/${idNegocio}/Sesiones/${idSesion}/FirmasHojaEnf/${loadFirmaPac}`}
                      alt="signature"
                      style={{
                        height: "200px",
                        padding: "10px",
                        zIndex: "-1",
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="text-center col-lg-6 col-md-6 col-sm-6">
                  <Text weight="semibold" color={styleFont}>
                    {enfermera}
                  </Text>
                </div>
                <div className="text-center col-lg-6 col-md-6 col-sm-6">
                  <Text weight="semibold" color={styleFont}>
                    {paciente}
                  </Text>
                </div>
              </div>
              <div className="row">
                <div
                  className="text-center col-lg-6 col-md-6 col-sm-6"
                  style={{
                    borderTop: "solid 0.1em",
                    borderTopColor: styleFont,
                  }}
                >
                  <Text size={"md"} weight="semibold" color={styleFont}>
                    Firma de enfermero(a)
                  </Text>
                </div>
                <div
                  className="text-center col-lg-6 col-md-6 col-sm-6"
                  style={{
                    borderTop: "solid 0.1em",
                    borderTopColor: styleFont,
                  }}
                >
                  <Text size={"md"} weight="semibold" color={styleFont}>
                    Firma del paciente
                  </Text>
                </div>
              </div>
            </Splitter.Panel>
            <Splitter.Panel>
              <Box mb={5}>
                <Text weight="bold" size={"md"} color={styleFont}>
                  META INTERNACIONAL 4: LISTA DE VERIFICACIÓN PRE-PROCEDIMIENTO
                </Text>
              </Box>
              <Table key={`tblMeta`} bordered responsive size="md">
                <thead>
                  {dataVerificaProc.length > 0 ? (
                    dataVerificaProc.map((item, index) => (
                      <tr key={`${index}`}>
                        <th
                          key={`cell-1-${index}`}
                          style={{ color: styleFont }}
                        >
                          {item.NombrePreProc}
                        </th>
                        <th
                          key={`cell2-${index}`}
                          style={{ color: styleFont, textAlign: "center" }}
                        >
                          {item.respuesta}
                        </th>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <th></th>
                    </tr>
                  )}
                </thead>
              </Table>
              <Box mb={5}>
                <Text weight="bold" size={"md"} color={styleFont}>
                  Determinación del grado de riesgo de caída al termino de
                  sesión.
                </Text>
              </Box>
              <Table
                key={`tblDetermina`}
                responsive
                size="sm"
                style={{ width: "90%" }}
              >
                <thead>
                  <tr>
                    <th>
                      <Text size={"md"} color={styleFont}>
                        Nivel
                      </Text>
                    </th>
                    <th style={{ textAlign: "center" }}>
                      <Text size={"md"} color={styleFont}>
                        Puntos
                      </Text>
                    </th>
                    <th style={{ textAlign: "center" }}>
                      <Text size={"md"} color={styleFont}>
                        Marque con una X
                      </Text>
                    </th>
                  </tr>
                  <tr>
                    <th style={{ color: styleFont }}>Alto riesgo</th>
                    <th style={{ textAlign: "center", color: styleFont }}>
                      4-10
                    </th>
                    <th style={{ textAlign: "center", color: styleFont }}>
                      <Checkbox
                        bordered
                        checked={gradoRiesgo === 4 ? true : false}
                        onClick={(e) => handleChecked(e.target.checked, 4)}
                        disabled={true}
                      />
                    </th>
                  </tr>
                  <tr>
                    <th style={{ color: styleFont }}>Mediano</th>
                    <th style={{ textAlign: "center", color: styleFont }}>
                      2-3
                    </th>
                    <th style={{ textAlign: "center", color: styleFont }}>
                      <Checkbox
                        bordered
                        checked={gradoRiesgo === 2 ? true : false}
                        onClick={(e) => handleChecked(e.target.checked, 2)}
                        disabled={true}
                      />
                    </th>
                  </tr>
                  <tr>
                    <th style={{ color: styleFont }}>Bajo</th>
                    <th style={{ textAlign: "center", color: styleFont }}>
                      0-1
                    </th>
                    <th style={{ textAlign: "center", color: styleFont }}>
                      <Checkbox
                        bordered
                        checked={gradoRiesgo === 0 ? true : false}
                        onClick={(e) => handleChecked(e.target.checked, 0)}
                        disabled={true}
                      />
                    </th>
                  </tr>
                </thead>
              </Table>
            </Splitter.Panel>
          </Splitter>
        </div>
        {/* <Image
      src={`/Images/Negocios/${idNegocio}/bottom-cornerImageHoja.png`}
      style={{
        width: "450px",
        position: "absolute",
        left: "0%",
        bottom: "0%",
        zIndex: "-1",
      }}
    /> */}
      </div>
    </>
  );
};
